export const movies = [
  {
    id: "m1",
    title: "星海远征",
    category: "movie",
    genres: ["科幻", "冒险", "剧情"],
    region: "中国大陆",
    year: 2025,
    rating: 8.9,
    duration: 142,
    director: "陆知远",
    actors: ["陈砚舟", "苏黎", "林拓", "许青禾"],
    releaseDate: "2025-07-18",
    summary: "人类首次向银河系边缘派出载人远征队，一场跨越光年的孤独航行与人性抉择。",
    synopsis:
      "公元2179年，地球资源濒临枯竭。远航舰「烛龙号」承载着人类最后的希望驶向银河系悬臂深处。舰长顾沉舟必须在补给耗尽、船员信念动摇的双重压力下完成一次几乎不可能返航的航行。当舰队抵达目标星域时，他们发现那里并非荒芜，而是一段被时光掩埋的文明低语。影片以冷静克制的镜头语言，探讨孤独、信念与人类文明的延续。",
    tags: ["太空", "硬科幻", "人性", "视效大片"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20science%20fiction%20movie%20poster%20art%2C%20deep%20navy%20cosmic%20background%20with%20a%20glowing%20spiral%20nebula%2C%20silhouette%20of%20a%20lone%20astronaut%20facing%20a%20vast%20starship%2C%20dramatic%20rim%20lighting%2C%20moody%20blue%20and%20amber%20tones%2C%20high%20detail%20film%20key%20art%2C%20vertical%20composition%2C%20professional%20poster%20design&width=600&height=900&seq=keke-m1-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Epic%20space%20scene%2C%20immense%20starship%20drifting%20toward%20a%20luminous%20nebula%2C%20deep%20dark%20blue%20cosmos%20with%20warm%20amber%20engine%20glow%2C%20cinematic%20wide%20shot%2C%20volumetric%20light%2C%20ultra%20detailed%20film%20still%2C%20dramatic%20atmosphere&width=1600&height=900&seq=keke-m1-back&orientation=landscape",
  },
  {
    id: "m2",
    title: "无声证词",
    category: "movie",
    genres: ["悬疑", "犯罪", "剧情"],
    region: "中国大陆",
    year: 2024,
    rating: 8.4,
    duration: 118,
    director: "韩沐",
    actors: ["周衍", "白瑾", "柯明"],
    releaseDate: "2024-11-08",
    summary: "一桩没有目击者的旧案，让沉默二十年的真相在庭审现场缓缓浮现。",
    synopsis:
      "辩护律师程微接下一桩几乎定案的杀人旧案，唯一的线索是一段残缺的监控与一名始终不肯开口的证人。随着调查深入，她发现真相并不在于谁开了枪，而在于谁选择了沉默。法庭内外的博弈交织成一张密不透风的网，每个人都在用自己的方式保护着某个秘密。",
    tags: ["悬疑", "庭审", "社会派", "反转"],
    poster:
      "https://readdy.ai/api/search-image?query=Moody%20crime%20thriller%20movie%20poster%2C%20dark%20charcoal%20background%20with%20a%20single%20shaft%20of%20cold%20light%20through%20a%20courtroom%20window%2C%20silhouette%20of%20a%20woman%20in%20profile%2C%20high%20contrast%20noir%20lighting%2C%20muted%20teal%20and%20amber%20accents%2C%20cinematic%20key%20art%2C%20vertical%20composition&width=600&height=900&seq=keke-m2-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Dark%20cinematic%20courtroom%20interior%20at%20dusk%2C%20rain%20streaked%20tall%20windows%2C%20single%20overhead%20lamp%20casting%20long%20shadows%2C%20noir%20crime%20film%20still%2C%20deep%20charcoal%20and%20teal%20palette%20with%20warm%20amber%20highlight%2C%20atmospheric%2C%20ultra%20detailed&width=1600&height=900&seq=keke-m2-back&orientation=landscape",
  },
  {
    id: "m3",
    title: "长安十二夜",
    category: "movie",
    genres: ["古装", "历史", "剧情"],
    region: "中国大陆",
    year: 2025,
    rating: 8.6,
    duration: 156,
    director: "沈砚清",
    actors: ["顾长风", "柳含烟", "谢无咎", "沈昭"],
    releaseDate: "2025-02-14",
    summary: "上元灯节前的十二个夜晚，一场关于家国、信义与权谋的无声较量。",
    synopsis:
      "盛唐长安，上元灯节将至，整座城池却暗流涌动。少府监小吏裴珏无意间卷入一桩牵连朝堂的密谋，他必须在十二个夜晚内找出真相，才能保住无辜者与这座城的繁华。灯火辉煌的街市之下，是层层叠叠的旧怨与新仇。影片以恢弘场景与细腻人物刻画，重现一个时代的气象与悲欢。",
    tags: ["盛唐", "权谋", "群像", "美术考究"],
    poster:
      "https://readdy.ai/api/search-image?query=Historical%20Chinese%20epic%20movie%20poster%2C%20ancient%20Chang&width=600&height=900&seq=keke-m3-poster&orientation=portrait'an city at night with thousands of glowing lanterns%2C silhouette of a robed figure on a city wall%2C warm amber and deep crimson palette against dark blue sky%2C ornate cinematic key art%2C vertical composition%2C highly detailed",
    backdrop:
      "https://readdy.ai/api/search-image?query=Panoramic%20ancient%20Chinese%20city%20at%20night%2C%20endless%20rows%20of%20glowing%20red%20lanterns%2C%20grand%20palace%20roofs%20under%20deep%20blue%20sky%2C%20misty%20atmosphere%2C%20epic%20historical%20film%20still%2C%20warm%20amber%20light%20against%20cool%20blue%20shadows%2C%20ultra%20detailed&width=1600&height=900&seq=keke-m3-back&orientation=landscape",
  },
  {
    id: "m4",
    title: "深海回响",
    category: "movie",
    genres: ["科幻", "惊悚", "悬疑"],
    region: "英国",
    year: 2024,
    rating: 7.9,
    duration: 126,
    director: "Oliver Grant",
    actors: ["Eleanor Reid", "Marcus Hale", "Nina Cole"],
    releaseDate: "2024-09-27",
    summary: "马里亚纳海沟深处的科研站收到一段不该存在的声波信号。",
    synopsis:
      "深海科研站的六名研究员在完成常规勘测时，捕捉到一段来自海沟最深处、规律得不像是自然产生的声波。为了确认信号来源，他们不得不下潜到连阳光都未曾抵达的地方。随着深度增加，设备开始失灵，队员之间也出现了无法解释的幻觉。科学的边界与人心的深渊，究竟哪一个更深？",
    tags: ["深海", "幽闭", "科幻惊悚", "音效"],
    poster:
      "https://readdy.ai/api/search-image?query=Underwater%20sci-fi%20horror%20poster%2C%20deep%20dark%20ocean%20trench%20with%20faint%20bioluminescent%20glow%2C%20tiny%20submersible%20silhouette%20against%20immense%20black%20depth%2C%20cold%20cyan%20and%20abyss%20black%20palette%2C%20eerie%20cinematic%20key%20art%2C%20vertical%20composition&width=600&height=900&seq=keke-m4-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Deep%20sea%20trench%20interior%2C%20small%20research%20submersible%20descending%20into%20pitch%20black%20darkness%2C%20faint%20bioluminescent%20particles%20drifting%2C%20cold%20cyan%20light%20beam%20cutting%20through%20murk%2C%20claustrophobic%20cinematic%20film%20still%2C%20ultra%20detailed%20atmosphere&width=1600&height=900&seq=keke-m4-back&orientation=landscape",
  },
  {
    id: "m5",
    title: "春日慢递",
    category: "movie",
    genres: ["爱情", "剧情"],
    region: "日本",
    year: 2025,
    rating: 8.2,
    duration: 108,
    director: "佐藤和也",
    actors: ["宫本遥", "松田悠真", "伊藤沙罗"],
    releaseDate: "2025-04-05",
    summary: "一间只投递手写信的旧邮局，串起两个人跨越四季的缓慢相遇。",
    synopsis:
      "小镇上有一间快要停业的旧邮局，负责投递镇上唯一有人手写的信件。失业返乡的凉太成为这里最后的邮差，而每一封寄往东京的信，都署名同一个人——在花店工作的春子。两人从未见面，却在一封封往返的信里，慢慢读懂了对方的生活与孤独。这是一段关于等待、关于慢下来的温柔故事。",
    tags: ["治愈", "书信", "小镇", "四季"],
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20romantic%20Japanese%20film%20poster%2C%20soft%20spring%20landscape%20with%20cherry%20blossoms%20and%20a%20small%20old%20post%20office%2C%20gentle%20pastel%20pink%20and%20sage%20green%20palette%2C%20sunlight%20through%20paper%20letters%2C%20delicate%20cinematic%20key%20art%2C%20vertical%20composition&width=600&height=900&seq=keke-m5-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Peaceful%20rural%20Japanese%20town%20in%20spring%2C%20cherry%20blossom%20trees%20lining%20a%20quiet%20lane%2C%20small%20old%20wooden%20post%20office%2C%20soft%20warm%20sunlight%20and%20gentle%20breeze%2C%20serene%20romantic%20film%20still%2C%20pastel%20palette%2C%20ultra%20detailed&width=1600&height=900&seq=keke-m5-back&orientation=landscape",
  },
  {
    id: "m6",
    title: "铁血山河",
    category: "movie",
    genres: ["战争", "历史", "剧情"],
    region: "中国大陆",
    year: 2024,
    rating: 8.1,
    duration: 150,
    director: "秦牧之",
    actors: ["贺兰山", "孟川", "罗正", "齐悦"],
    releaseDate: "2024-08-01",
    summary: "一支后勤运输连队，用血肉之躯在炮火中守住一条补给线。",
    synopsis:
      "战争年代，一支并不起眼的后勤运输连队承担着向前线输送物资的任务。他们没有登上过庆功的名单，却用一次次穿越火线的往返，撑起了战局的转折。连长老周带着这群平均年龄不到二十岁的年轻人，在泥泞、饥饿与炮火中学会担当。影片以群像叙事，致敬那些被历史记住又遗忘的普通人。",
    tags: ["群像", "热血", "写实", "信念"],
    poster:
      "https://readdy.ai/api/search-image?query=Gritty%20war%20drama%20movie%20poster%2C%20silhouettes%20of%20soldiers%20marching%20through%20smoke%20at%20dawn%2C%20muddy%20earth%20tones%20with%20a%20single%20warm%20orange%20sunbreak%2C%20weathered%20cinematic%20key%20art%2C%20vertical%20composition%2C%20dramatic%20and%20heroic%20mood&width=600&height=900&seq=keke-m6-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=War%20era%20supply%20column%20on%20a%20muddy%20road%20at%20dawn%2C%20figures%20silhouetted%20against%20glowing%20orange%20smoke%2C%20burnt%20ochre%20and%20grey%20palette%2C%20gritty%20realistic%20film%20still%2C%20dramatic%20volumetric%20light%2C%20ultra%20detailed&width=1600&height=900&seq=keke-m6-back&orientation=landscape",
  },
  {
    id: "m7",
    title: "都市迷航",
    category: "movie",
    genres: ["剧情", "悬疑"],
    region: "中国香港",
    year: 2025,
    rating: 7.7,
    duration: 114,
    director: "陈以朗",
    actors: ["郑子谦", "何韵", "麦嘉豪"],
    releaseDate: "2025-05-23",
    summary: "一名夜班出租车司机，在一晚之内载上了改变他命运的三位乘客。",
    synopsis:
      "老陈开了二十年夜班出租，早已习惯城市的沉默。一个雨夜，他接连载上三位看似毫无关联的乘客：一个急着赴约的律师、一个抱着旧箱子的老人、一个不断看表的少女。当目的地一一抵达，老陈才意识到自己也在某一程之中，而这一晚将重新定义他此后的人生。",
    tags: ["城市", "夜景", "人生", "群像"],
    poster:
      "https://readdy.ai/api/search-image?query=Urban%20drama%20movie%20poster%2C%20rain%20soaked%20neon%20city%20street%20at%20night%2C%20lone%20taxi%20with%20glowing%20headlights%2C%20reflective%20wet%20asphalt%2C%20moody%20indigo%20and%20warm%20amber%20street%20light%20palette%2C%20cinematic%20key%20art%2C%20vertical%20composition&width=600&height=900&seq=keke-m7-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Rainy%20metropolitan%20night%20street%2C%20a%20single%20taxi%20window%20reflecting%20passing%20city%20lights%2C%20shallow%20depth%20of%20field%2C%20indigo%20shadows%20and%20amber%20streetlamp%20glow%2C%20melancholic%20cinematic%20film%20still%2C%20ultra%20detailed%20bokeh&width=1600&height=900&seq=keke-m7-back&orientation=landscape",
  },
  {
    id: "m8",
    title: "笑闹厨房",
    category: "movie",
    genres: ["喜剧", "家庭"],
    region: "中国大陆",
    year: 2025,
    rating: 7.5,
    duration: 102,
    director: "冯乐天",
    actors: ["大彭", "李多喜", "武小满", "张一勺"],
    releaseDate: "2025-01-29",
    summary: "一家濒临倒闭的老饭馆，被一群「不靠谱」的家人生生救了回来。",
    synopsis:
      "城南的「满福楼」开了三十年，如今门可罗雀。老板老满突发奇想要把店交给从没下过厨的三个子女接手，一场鸡飞狗跳的厨房大战就此上演。糊掉的汤、放错盐的菜、闹上门的食客、追债的债主……在一次次手忙脚乱中，这家人重新找回了味道，也找回了一直被忽略的彼此。",
    tags: ["合家欢", "美食", "温情", "爆笑"],
    poster:
      "https://readdy.ai/api/search-image?query=Playful%20family%20comedy%20movie%20poster%2C%20cheerful%20cluttered%20Chinese%20restaurant%20kitchen%20with%20flying%20flour%20and%20colorful%20vegetables%2C%20warm%20cream%20and%20tomato%20red%20palette%2C%20whimsical%20illustration%20style%20cinematic%20key%20art%2C%20vertical%20composition&width=600&height=900&seq=keke-m8-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cozy%20vintage%20Chinese%20restaurant%20interior%2C%20steam%20rising%20from%20steaming%20dishes%2C%20warm%20golden%20hanging%20lights%2C%20lively%20cheerful%20atmosphere%2C%20warm%20cream%20and%20crimson%20palette%2C%20comedic%20film%20still%2C%20ultra%20detailed&width=1600&height=900&seq=keke-m8-back&orientation=landscape",
  },
  {
    id: "m9",
    title: "极地孤影",
    category: "movie",
    genres: ["冒险", "生存", "剧情"],
    region: "法国",
    year: 2024,
    rating: 8.3,
    duration: 120,
    director: "Claire Dubois",
    actors: ["Julien Moreau", "Anaïs Petit"],
    releaseDate: "2024-12-13",
    summary: "一场暴风雪后，极地科考站只剩她一个人，和四十天的口粮。",
    synopsis:
      "极地科考站遭遇百年一遇的风暴，通讯中断、同伴失联，留下的探险者艾拉必须独自撑过漫长的极夜。她记录每天的温度、清点逐渐减少的物资，也记录自己越来越难以分辨的清醒与幻觉。当救援或许永远不会到来的念头浮现，她依然每天走出舱门，走向暴风雪深处。",
    tags: ["极地", "生存", "孤独", "纪实感"],
    poster:
      "https://readdy.ai/api/search-image?query=Arctic%20survival%20movie%20poster%2C%20vast%20white%20snow%20plain%20under%20dark%20polar%20sky%2C%20tiny%20solitary%20figure%20walking%20toward%20blizzard%2C%20icy%20blue%20and%20stark%20white%20palette%20with%20faint%20warm%20breath%20glow%2C%20stark%20cinematic%20key%20art%2C%20vertical%20composition&width=600&height=900&seq=keke-m9-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Endless%20frozen%20polar%20landscape%20during%20polar%20night%2C%20small%20research%20station%20under%20a%20vast%20starry%20sky%2C%20cold%20blue%20and%20pale%20white%20palette%2C%20isolated%20atmospheric%20film%20still%2C%20ultra%20detailed%20snow%20texture&width=1600&height=900&seq=keke-m9-back&orientation=landscape",
  },
  {
    id: "m10",
    title: "时间褶皱",
    category: "movie",
    genres: ["科幻", "剧情", "悬疑"],
    region: "美国",
    year: 2025,
    rating: 8.5,
    duration: 134,
    director: "Daniel Frost",
    actors: ["Owen Blake", "Sofia Marin", "Ethan Cho"],
    releaseDate: "2025-03-21",
    summary: "一位物理学家发现，她每天都会在同一天的清晨重新醒来。",
    synopsis:
      "物理学家海伦在一次失败的实验后，发现自己被困在同一个清晨。起初她以为只是设备故障，直到她发现每次循环都在留下细微的变化——而这些变化，正拼凑出实验失败背后真正的秘密。为了走出这一天，她必须弄清楚，究竟是时间出了错，还是她自己不愿面对某个答案。",
    tags: ["时间循环", "烧脑", "悬疑", "情感"],
    poster:
      "https://readdy.ai/api/search-image?query=Mind%20bending%20sci-fi%20movie%20poster%2C%20shattered%20mirror-like%20fragments%20of%20a%20city%20skyline%20suspended%20in%20dark%20space%2C%20glowing%20amber%20fissures%20between%20glass%20shards%2C%20deep%20indigo%20and%20gold%20palette%2C%20intricate%20cinematic%20key%20art%2C%20vertical%20composition&width=600&height=900&seq=keke-m10-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Abstract%20sci-fi%20laboratory%20at%20dawn%2C%20floating%20shards%20of%20glass%20refracting%20warm%20golden%20light%2C%20deep%20indigo%20shadows%2C%20surreal%20time%20distortion%20visual%2C%20intricate%20cinematic%20film%20still%2C%20ultra%20detailed&width=1600&height=900&seq=keke-m10-back&orientation=landscape",
  },
];

export const tvSeries = [
  {
    id: "t1",
    title: "云顶之城",
    category: "tvseries",
    genres: ["剧情", "都市", "商战"],
    region: "中国大陆",
    year: 2025,
    rating: 8.7,
    episodes: 36,
    director: "姜北望",
    actors: ["裴清源", "温以宁", "顾南乔", "徐立"],
    releaseDate: "2025-06-06",
    summary: "一座云端设计之城背后的资本博弈，与两个家族跨越十余年的纠葛。",
    synopsis:
      "年轻建筑师闻溪带着一张未完成的设计图回到故乡，试图完成父亲生前未竟的「云顶之城」项目。然而这片土地早已被资本与旧日恩怨切割成无数阵营。在理想与现实的拉扯中，她与昔日的对手并肩，也一步步揭开项目背后被掩埋的真相。",
    tags: ["商战", "家族", "理想", "群像"],
    poster:
      "https://readdy.ai/api/search-image?query=Modern%20urban%20drama%20series%20poster%2C%20futuristic%20glass%20skyscrapers%20rising%20above%20soft%20clouds%2C%20lonely%20figure%20silhouette%20on%20a%20rooftop%20at%20dusk%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20sleek%20cinematic%20key%20art%2C%20vertical%20composition&width=600&height=900&seq=keke-t1-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Modern%20city%20skyline%20above%20low%20hanging%20clouds%20at%20golden%20hour%2C%20gleaming%20glass%20towers%2C%20deep%20navy%20blue%20sky%20with%20warm%20amber%20sunlight%2C%20ambitious%20urban%20drama%20series%20still%2C%20ultra%20detailed&width=1600&height=900&seq=keke-t1-back&orientation=landscape",
  },
  {
    id: "t2",
    title: "山河故人传",
    category: "tvseries",
    genres: ["古装", "历史", "剧情"],
    region: "中国大陆",
    year: 2024,
    rating: 8.9,
    episodes: 46,
    director: "卫昭",
    actors: ["萧怀瑾", "苏晚棠", "陆行舟", "商雪"],
    releaseDate: "2024-10-01",
    summary: "乱世之中，一位寒门书生与一位亡国公主共同守护山河的故事。",
    synopsis:
      "王朝更替的年代，寒门出身的谋士谢屿在乱世中遇见流亡的公主姜昭。一个想以智谋定天下，一个想以旧身份换太平。两人从相互试探到生死相托，在群雄逐鹿的棋局中，走出了一条既关乎家国也关乎知己的路。剧集以考究的服化道与扎实的群像塑造，铺陈出一幅宏阔的历史长卷。",
    tags: ["乱世", "权谋", "知己", "大制作"],
    poster:
      "https://readdy.ai/api/search-image?query=Grand%20historical%20Chinese%20drama%20poster%2C%20misty%20mountains%20and%20ancient%20city%20walls%2C%20silhouettes%20of%20a%20scholar%20and%20a%20noblewoman%20in%20flowing%20robes%2C%20muted%20ink%20blue%20and%20warm%20gold%20palette%2C%20elegant%20cinematic%20key%20art%2C%20vertical%20composition&width=600&height=900&seq=keke-t2-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Sweeping%20Chinese%20historical%20landscape%2C%20misty%20layered%20mountains%20with%20an%20ancient%20walled%20city%2C%20dramatic%20pale%20blue%20and%20gold%20light%2C%20epic%20period%20drama%20series%20still%2C%20ultra%20detailed%20atmospheric&width=1600&height=900&seq=keke-t2-back&orientation=landscape",
  },
  {
    id: "t3",
    title: "沉默的证人",
    category: "tvseries",
    genres: ["悬疑", "犯罪", "刑侦"],
    region: "中国大陆",
    year: 2025,
    rating: 8.5,
    episodes: 24,
    director: "罗劲松",
    actors: ["谭亦铭", "祝晚", "关山", "柳岩青"],
    releaseDate: "2025-03-14",
    summary: "法医老谭与刑警队，用一具具沉默的身体讲述被隐藏的真相。",
    synopsis:
      "资深法医谭亦铭习惯用最笨的办法破案——把每一处细节都看到底。当一系列看似独立的案件因为一种罕见的痕迹而被串联起来，他与年轻刑警祝晚组成了临时搭档。两人一个信证据、一个信直觉，在层层迷雾中逼近真相，也逐渐理解了彼此坚持的意义。",
    tags: ["法医", "刑侦", "单元剧", "烧脑"],
    poster:
      "https://readdy.ai/api/search-image?query=Crime%20investigation%20series%20poster%2C%20cold%20clinical%20laboratory%20setting%2C%20close%20silhouette%20of%20a%20forensic%20expert%20examining%20evidence%2C%20desaturated%20teal%20and%20charcoal%20palette%20with%20a%20single%20amber%20light%2C%20tense%20cinematic%20key%20art%2C%20vertical%20composition&width=600&height=900&seq=keke-t3-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Forensic%20laboratory%20at%20night%2C%20cool%20teal%20lighting%20over%20stainless%20steel%20instruments%2C%20glass%20evidence%20wall%20with%20photographs%2C%20quiet%20tense%20atmosphere%2C%20crime%20drama%20series%20still%2C%20ultra%20detailed&width=1600&height=900&seq=keke-t3-back&orientation=landscape",
  },
  {
    id: "t4",
    title: "医者仁心录",
    category: "tvseries",
    genres: ["医疗", "剧情", "都市"],
    region: "中国大陆",
    year: 2024,
    rating: 8.3,
    episodes: 32,
    director: "许承安",
    actors: ["江屿", "叶晚晴", "高振国", "林逸"],
    releaseDate: "2024-09-09",
    summary: "急诊科的一盏长明灯，照见生死之间的坚守与成长。",
    synopsis:
      "年轻医生江屿初入急诊科，面对的是永远排不完的号、永远不够用的床位与永远来不及说的告别。在严厉的主任与温柔的护士长之间，他学会的不只是技术，更是如何在有限的时间里给出最大的善意。剧集以一个个真实的急诊故事，致敬每一位守住长明灯的人。",
    tags: ["急诊", "医患", "成长", "温情"],
    poster:
      "https://readdy.ai/api/search-image?query=Medical%20drama%20series%20poster%2C%20soft%20hospital%20corridor%20light%2C%20back%20view%20of%20a%20doctor%20in%20white%20coat%20walking%20forward%2C%20clean%20pale%20blue%20and%20warm%20white%20palette%20with%20amber%20highlight%2C%20hopeful%20cinematic%20key%20art%2C%20vertical%20composition&width=600&height=900&seq=keke-t4-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Night%20shift%20hospital%20emergency%20corridor%2C%20soft%20glowing%20overhead%20lights%2C%20blurred%20medical%20team%20rushing%20past%2C%20clean%20pale%20palette%20with%20warm%20accents%2C%20heartfelt%20medical%20drama%20still%2C%20ultra%20detailed&width=1600&height=900&seq=keke-t4-back&orientation=landscape",
  },
  {
    id: "t5",
    title: "星际拓荒者",
    category: "tvseries",
    genres: ["科幻", "冒险", "剧情"],
    region: "美国",
    year: 2025,
    rating: 8.8,
    episodes: 10,
    director: "Rachel Voss",
    actors: ["Nathan Cole", "Priya Raman", "Diego Vega"],
    releaseDate: "2025-08-22",
    summary: "第一批定居者在陌生星球上，重建文明的第一块砖。",
    synopsis:
      "作为第一批在系外行星扎根的人类，拓荒者们带着有限的资源与无限的野心降落在伽马星。他们需要在这里种植作物、建立能源、维系脆弱的秩序。然而这颗星球并不欢迎他们——未知的生态、稀缺的水源、以及队伍内部逐渐分化的理念，都在考验着「人类文明」这个词真正的重量。",
    tags: ["殖民", "硬科幻", "群像", "生存"],
    poster:
      "https://readdy.ai/api/search-image?query=Sci-fi%20colony%20series%20poster%2C%20red%20rock%20alien%20planet%20with%20a%20dome%20habitat%20at%20dusk%2C%20two%20suns%20low%20on%20the%20horizon%2C%20distant%20astronaut%20silhouettes%2C%20dusty%20orange%20and%20deep%20blue%20palette%2C%20epic%20cinematic%20key%20art%2C%20vertical%20composition&width=600&height=900&seq=keke-t5-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Alien%20colony%20settlement%20on%20a%20red%20desert%20planet%20at%20dusk%2C%20domed%20habitats%20glowing%20warmly%2C%20two%20suns%20setting%20on%20a%20vast%20horizon%2C%20dusty%20orange%20and%20deep%20indigo%20palette%2C%20epic%20sci-fi%20series%20still%2C%20ultra%20detailed&width=1600&height=900&seq=keke-t5-back&orientation=landscape",
  },
  {
    id: "t6",
    title: "我们的八零年代",
    category: "tvseries",
    genres: ["年代", "家庭", "剧情"],
    region: "中国大陆",
    year: 2024,
    rating: 8.6,
    episodes: 40,
    director: "方晓东",
    actors: ["郑海涛", "刘桂兰", "小满", "周立"],
    releaseDate: "2024-07-05",
    summary: "一条老街、五户人家，讲述一代人共同走过的烟火岁月。",
    synopsis:
      "从工厂大院到街边小卖部，从黑白电视到第一台录音机，剧集以一整条老街为舞台，讲述了五个普通家庭在八零年代的悲欢离合。孩子们在巷子里长大，大人们在时代的浪潮里沉浮。那些被时间带走的热闹与喧哗，构成了这一代人最柔软的集体记忆。",
    tags: ["年代感", "烟火气", "群像", "怀旧"],
    poster:
      "https://readdy.ai/api/search-image?query=Nostalgic%20period%20drama%20poster%2C%20warm%20retro%20street%20scene%20from%20the%201980s%2C%20bicycles%20and%20old%20courtyard%20buildings%2C%20faded%20warm%20yellow%20and%20dusty%20green%20palette%2C%20film%20grain%20texture%2C%20heartfelt%20cinematic%20key%20art%2C%20vertical%20composition&width=600&height=900&seq=keke-t6-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Retro%201980s%20Chinese%20neighborhood%20street%20at%20dusk%2C%20old%20courtyard%20houses%20and%20bicycles%2C%20warm%20amber%20streetlights%2C%20faded%20nostalgic%20film%20grain%2C%20warm%20sepia%20and%20green%20palette%2C%20period%20drama%20still%2C%20ultra%20detailed&width=1600&height=900&seq=keke-t6-back&orientation=landscape",
  },
  {
    id: "t7",
    title: "暗巷探案集",
    category: "tvseries",
    genres: ["悬疑", "刑侦", "犯罪"],
    region: "中国香港",
    year: 2025,
    rating: 8.4,
    episodes: 20,
    director: "黄志森",
    actors: ["麦子豪", "阮清", "陈伯"],
    releaseDate: "2025-04-18",
    summary: "老城区的一条暗巷里，藏着这座城市最不愿意被翻开的故事。",
    synopsis:
      "退休老刑警陈伯被返聘回警队，负责梳理一件搁置多年的旧案。线索指向城中最老的一片街区，那里住着不愿搬走的老人、说不清来历的租客，以及一条所有人都心照不宣的暗巷。随着调查推进，陈伯发现真相远比案件本身更沉重。",
    tags: ["老城区", "旧案", "港味", "人性"],
    poster:
      "https://readdy.ai/api/search-image?query=Hong%20Kong%20crime%20mystery%20series%20poster%2C%20narrow%20alley%20with%20hanging%20neon%20signs%20glinting%20in%20rain%2C%20lone%20detective%20silhouette%2C%20moody%20teal%20and%20amber%20neon%20palette%2C%20noir%20cinematic%20key%20art%2C%20vertical%20composition&width=600&height=900&seq=keke-t7-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Rainy%20narrow%20Hong%20Kong%20alley%20at%20night%2C%20glowing%20neon%20signs%20reflecting%20on%20wet%20pavement%2C%20silhouette%20of%20an%20older%20detective%20walking%20away%2C%20moody%20teal%20and%20amber%20palette%2C%20noir%20crime%20series%20still%2C%20ultra%20detailed&width=1600&height=900&seq=keke-t7-back&orientation=landscape",
  },
  {
    id: "t8",
    title: "风起江湖",
    category: "tvseries",
    genres: ["武侠", "古装", "动作"],
    region: "中国大陆",
    year: 2025,
    rating: 8.2,
    episodes: 38,
    director: "燕南归",
    actors: ["霍青崖", "沈流云", "白无咎", "乔霜"],
    releaseDate: "2025-05-30",
    summary: "一柄失落多年的旧剑，牵出江湖沉寂已久的恩怨。",
    synopsis:
      "出身镖局的少女霍青崖意外得到一柄传说中的旧剑，从此被卷入江湖各方势力的追逐。她怀揣着一桩旧日血案，踏上寻找真相的路。一路上，她结识了看似散漫实则通透的剑客白无咎，也看清了所谓名门正派背后难以言说的算计。江湖不只是恩怨，更是人心。",
    tags: ["快意恩仇", "江湖", "成长", "武打"],
    poster:
      "https://readdy.ai/api/search-image?query=Wuxia%20martial%20arts%20series%20poster%2C%20misty%20bamboo%20forest%20with%20a%20lone%20swordswoman%20silhouette%20holding%20an%20old%20blade%2C%20ink%20wash%20painting%20aesthetic%2C%20muted%20sage%20green%20and%20pale%20gold%20palette%2C%20elegant%20cinematic%20key%20art%2C%20vertical%20composition&width=600&height=900&seq=keke-t8-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Misty%20bamboo%20forest%20at%20dawn%2C%20swordswoman%20silhouette%20standing%20on%20a%20rock%20ledge%2C%20drifting%20fog%20and%20soft%20pale%20light%2C%20ink%20painting%20inspired%20palette%2C%20elegant%20wuxia%20series%20still%2C%20ultra%20detailed&width=1600&height=900&seq=keke-t8-back&orientation=landscape",
  },
  {
    id: "t9",
    title: "职场进化论",
    category: "tvseries",
    genres: ["都市", "职场", "喜剧"],
    region: "中国大陆",
    year: 2025,
    rating: 8.0,
    episodes: 28,
    director: "何小满",
    actors: ["林小满", "高天", "苏念", "马大川"],
    releaseDate: "2025-02-28",
    summary: "三个性格迥异的年轻人，在一家创业公司里摸爬滚打的日子。",
    synopsis:
      "清华毕业的林小满如愿进入一家创业公司，却发现自己被分到了全公司最「佛系」的部门。她与摸鱼高手高天、社恐设计师苏念组成临时项目组，从一窍不通到磕磕绊绊地拿下第一个客户。笑料百出的日常之下，是每一个普通打工人都似曾相识的成长。",
    tags: ["职场", "轻喜剧", "打工人", "成长"],
    poster:
      "https://readdy.ai/api/search-image?query=Modern%20workplace%20comedy%20series%20poster%2C%20bright%20open%20plan%20office%20with%20colorful%20sticky%20notes%2C%20three%20young%20coworkers%20in%20playful%20poses%2C%20cheerful%20coral%20orange%20and%20soft%20mint%20palette%2C%20lively%20cinematic%20key%20art%2C%20vertical%20composition&width=600&height=900&seq=keke-t9-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Bright%20modern%20startup%20office%20interior%2C%20young%20team%20brainstorming%20around%20a%20whiteboard%20with%20sticky%20notes%2C%20cheerful%20warm%20daylight%2C%20coral%20and%20mint%20accents%2C%20lighthearted%20workplace%20series%20still%2C%20ultra%20detailed&width=1600&height=900&seq=keke-t9-back&orientation=landscape",
  },
  {
    id: "t10",
    title: "山海食肆",
    category: "tvseries",
    genres: ["美食", "治愈", "剧情"],
    region: "中国大陆",
    year: 2024,
    rating: 8.7,
    episodes: 16,
    director: "苏木白",
    actors: ["秦知味", "阿桉", "老周"],
    releaseDate: "2024-11-22",
    summary: "山脚下的一间小食堂，用一道菜换一个故事。",
    synopsis:
      "城市边缘的山脚下，有一间只在傍晚开门的小食堂。老板娘秦知味从不问客人的来历，只根据他们的神情做一道菜。加班到深夜的程序员、失恋的花店姑娘、多年未见的老友……每个走进来的人，都能在这里吃过一顿饭的工夫，把心里的结轻轻解开一点。",
    tags: ["深夜食堂", "治愈", "烟火气", "慢综艺感"],
    poster:
      "https://readdy.ai/api/search-image?query=Healing%20food%20drama%20poster%2C%20cozy%20small%20eatery%20with%20warm%20lantern%20light%2C%20steaming%20homemade%20dishes%20on%20a%20wooden%20table%2C%20warm%20amber%20and%20earthy%20brown%20palette%2C%20intimate%20cinematic%20key%20art%2C%20vertical%20composition&width=600&height=900&seq=keke-t10-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cozy%20small%20Chinese%20eatery%20at%20night%20beside%20a%20mountain%2C%20warm%20lanterns%20glowing%2C%20steam%20rising%20from%20a%20home%20cooked%20meal%2C%20intimate%20warm%20amber%20palette%2C%20healing%20food%20drama%20still%2C%20ultra%20detailed&width=1600&height=900&seq=keke-t10-back&orientation=landscape",
  },
];

export const catalog = [...movies, ...tvSeries];

export const homeHeroSlides = [
  {
    id: "m1",
    tag: "院线热映",
    title: "星海远征",
    subtitle: "跨越光年的孤独航行，人类文明最后的希望",
    image:
      "https://readdy.ai/api/search-image?query=Epic%20space%20scene%2C%20immense%20starship%20drifting%20toward%20a%20luminous%20nebula%2C%20deep%20dark%20blue%20cosmos%20with%20warm%20amber%20engine%20glow%2C%20cinematic%20wide%20shot%2C%20volumetric%20light%2C%20ultra%20detailed%20film%20still%2C%20dramatic%20atmosphere&width=1600&height=900&seq=keke-m1-back&orientation=landscape",
  },
  {
    id: "t5",
    tag: "口碑剧集",
    title: "星际拓荒者",
    subtitle: "第一批定居者，在陌生星球重建文明的第一块砖",
    image:
      "https://readdy.ai/api/search-image?query=Alien%20colony%20settlement%20on%20a%20red%20desert%20planet%20at%20dusk%2C%20domed%20habitats%20glowing%20warmly%2C%20two%20suns%20setting%20on%20a%20vast%20horizon%2C%20dusty%20orange%20and%20deep%20indigo%20palette%2C%20epic%20sci-fi%20series%20still%2C%20ultra%20detailed&width=1600&height=900&seq=keke-t5-back&orientation=landscape",
  },
  {
    id: "m3",
    tag: "口碑佳作",
    title: "长安十二夜",
    subtitle: "灯火璀璨之下，一场关乎家国的无声较量",
    image:
      "https://readdy.ai/api/search-image?query=Panoramic%20ancient%20Chinese%20city%20at%20night%2C%20endless%20rows%20of%20glowing%20red%20lanterns%2C%20grand%20palace%20roofs%20under%20deep%20blue%20sky%2C%20misty%20atmosphere%2C%20epic%20historical%20film%20still%2C%20warm%20amber%20light%20against%20cool%20blue%20shadows%2C%20ultra%20detailed&width=1600&height=900&seq=keke-m3-back&orientation=landscape",
  },
  {
    id: "t2",
    tag: "年度大剧",
    title: "山河故人传",
    subtitle: "乱世之中，书生与公主共同守护的万里山河",
    image:
      "https://readdy.ai/api/search-image?query=Sweeping%20Chinese%20historical%20landscape%2C%20misty%20layered%20mountains%20with%20an%20ancient%20walled%20city%2C%20dramatic%20pale%20blue%20and%20gold%20light%2C%20epic%20period%20drama%20series%20still%2C%20ultra%20detailed%20atmospheric&width=1600&height=900&seq=keke-t2-back&orientation=landscape",
  },
];

export const collections = [
  {
    id: "c1",
    title: "年度高分科幻合辑",
    lead: "从太空歌剧到时间循环，精选近两年评分最亮眼的科幻作品，一次看懂硬核与浪漫的边界。",
    count: 24,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20sci-fi%20collection%20cover%20art%2C%20glowing%20geometric%20nebula%20and%20orbital%20rings%20in%20deep%20navy%20space%2C%20warm%20amber%20light%20accent%2C%20futuristic%20minimalist%20editorial%20design%2C%20high%20detail%2C%20cinematic&width=800&height=600&seq=keke-col-scifi&orientation=landscape",
  },
  {
    id: "c2",
    title: "悬疑烧脑必刷清单",
    lead: "层层反转、细节埋线，从庭审到刑侦，为喜欢边看边推理的你准备的深夜片单。",
    count: 18,
    image:
      "https://readdy.ai/api/search-image?query=Moody%20mystery%20collection%20cover%20art%2C%20fingerprint%20texture%20and%20dark%20glass%20shards%20with%20a%20single%20warm%20amber%20light%20beam%2C%20deep%20charcoal%20and%20teal%20palette%2C%20minimalist%20editorial%20design%2C%20cinematic%20detail&width=800&height=600&seq=keke-col-mystery&orientation=landscape",
  },
  {
    id: "c3",
    title: "治愈系慢生活片单",
    lead: "跟着一间旧邮局、一家小食堂和一条老街，把节奏放慢，重新体会好好吃饭的温柔。",
    count: 15,
    image:
      "https://readdy.ai/api/search-image?query=Warm%20healing%20collection%20cover%20art%2C%20soft%20morning%20light%20through%20wooden%20window%20onto%20a%20cup%20of%20tea%20and%20old%20letters%2C%20gentle%20amber%20and%20sage%20palette%2C%20cozy%20minimalist%20editorial%20design%2C%20high%20detail&width=800&height=600&seq=keke-col-healing&orientation=landscape",
  },
];